import PropTypes from 'prop-types';

import { StepApiContext } from './Context';
import useStepGateState from './hooks/useStepGateState';
import useStepperApi from './hooks/useStepperApi';

const StepGate = ({ children, id, label }) => {
  const { getStepApi, registerGate } = useStepperApi();
  const { isCurrentGate } = useStepGateState(id);

  registerGate(id, label);

  if (!isCurrentGate) return null;

  return (
    <StepApiContext.Provider value={getStepApi()}>
      {children}
    </StepApiContext.Provider>
  );
};

StepGate.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default StepGate;
